exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SkillView-module__wrapper___3BPRE{display:grid;gap:1rem}.SkillView-module__wrapper___3BPRE strong{text-transform:uppercase;margin-bottom:1rem;display:block}.SkillView-module__wrapper___3BPRE .SkillView-module__skills___zB4T4{display:grid;gap:1rem;grid-template-columns:repeat(auto-fill,minmax(120px,1fr))}.SkillView-module__wrapper___3BPRE .SkillView-module__soft___2TlfG{color:#a97efa}.SkillView-module__wrapper___3BPRE .SkillView-module__hard___3jcGL{color:#8450f8}.SkillView-module__wrapper___3BPRE .SkillView-module__top___CxohC{display:grid;gap:.75rem}@media screen and (min-width:1325px){.SkillView-module__wrapper___3BPRE .SkillView-module__top___CxohC{grid-template-columns:.7fr .3fr}}", ""]);

// exports
exports.locals = {
	"wrapper": "SkillView-module__wrapper___3BPRE",
	"skills": "SkillView-module__skills___zB4T4",
	"soft": "SkillView-module__soft___2TlfG",
	"hard": "SkillView-module__hard___3jcGL",
	"top": "SkillView-module__top___CxohC"
};